import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import PageLoader from 'components/PageLoader';

const CitizenManagement = lazy(() => import('pages/CitizenManagement'));
const CitizenManagementDetail = lazy(() => import('pages/CitizenManagementDetail'));
const CitizenManagementForm = lazy(() => import('pages/CitizenManagementForm'));

const CitizenManagementRoute = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<CitizenManagement />} />
        <Route path="/detail/:id" element={<CitizenManagementDetail />} />
        <Route path="/form/:user_id" element={<CitizenManagementForm />} />
      </Routes>
    </Suspense>
  );
};

export default CitizenManagementRoute;
